import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';

/**
 * Fetch available reports and their required filters for a given module (e.g., 'sales')
 */
export const getReportParameters = async (module, callback) => {
    try {
        const response = await risapi.get(`/api/parameter-report/${module}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * Generate the report.
 * Returns Blob for PDF, or JSON with base64 for Excel.
 */
export const generateReport = async (module, payload, callback) => {
    try {
        const config = getAxiosConfig();
        if (payload.reportFormat === 'pdf') {
            config.responseType = 'blob';
        }

        // ** FIX: Use the correct POST route 'report-generator' **
        const response = await risapi.post(`/api/parameter-report/${module}`, payload, config);

        if (response.status === 200) {
             callback(response.data);
        }
    } catch (error) {
        
        // Handle errors hidden inside a blob (like 422 validation errors when requesting a PDF)
        if (payload.reportFormat === 'pdf' && error.response && error.response.data instanceof Blob) {
             const reader = new FileReader();
             reader.onload = () => {
                 try {
                     // The blob contains our JSON error message
                     const errJson = JSON.parse(reader.result);
                     // Pass the error back in the same structure as a normal JSON error
                     callback({ error: { response: { data: errJson, status: error.response.status } } });
                 } catch (e) {
                     // Not JSON, generic error
                     handleApiError(error);
                     callback({ error: true });
                 }
             };
             reader.readAsText(error.response.data);
        }
        // Handle standard JSON errors (for Excel requests)
        else if (error.response && (error.response.status === 422 || error.response.status === 400)) {
            // Pass the full error object back to the component's callback
            callback({ error: error }); 
        }
        // Handle all other errors
         else {
             handleApiError(error);
             callback({ error: true });
        }
    }
};